<div mat-dialog-title style="float: left; width: 100%; background-color: #002b43; float: left; color:white;">
    <div style="width: 100%; background-color: #002b43; float: left; color:white;">
        <div style="width: 90%; float:left;">
            <div style="margin: 1em;">
                Mensaje del Sistema
            </div>
        </div>
    </div>
</div>
<div mat-dialog-content>
    <div style="margin: 1em; color: grey; font-size:small; text-align: center;">
        <p>
            {{obj}}
        </p>
    </div>
</div>
<div mat-dialog-actions>
    <div style="margin: 0 auto;">
        <div style="padding-bottom: 2em; text-align: center;">
            <button class="btnEntrar" (click)="closeDialog()" mat-button>Aceptar</button>
        </div>
    </div>
</div>